import { FieldConfigurationListComponent } from 'src/app/field-configuration/field-configuration-list/field-configuration-list.component';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FieldConfigurationEditComponent } from './field-configuration-edit/field-configuration-edit.component';
import { FieldConfigurationTestComponent } from './field-configuration-test/field-configuration-test.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@NgModule({
  imports: [
    SharedModule,
    NgxJsonViewerModule
  ],
  declarations: [
    FieldConfigurationEditComponent,
    FieldConfigurationListComponent,
    FieldConfigurationTestComponent
  ]
})
export class FieldConfigurationModule { }
